<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Master Pengumuman
            </div>
            <v-dialog v-model="dialogAddEvent" persistent max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="text-h5">Pengumuman</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <div class="row form-group" style="min-height: ">
                        <div class="col-md-2">
                          <v-avatar size="100px" v-ripple v-if="!url" class="grey lighten-3 mb-3">
                          </v-avatar>
                          <v-avatar size="100px" v-ripple v-else class="mb-3">
                            <v-img :src="url"></v-img>
                          </v-avatar>
                        </div>
                        <div class="col" style="align-content: bottom; display: flex">
                          <v-file-input @change="Preview_image" v-model="formData.data_foto"
                            placeholder="Upload Your Photo / Upload Foto (上传照片)" style="max-height: 100px"
                            class="fileInput" id="file" ref="file" :disabled="disableCounter" :rules="rulesImage">
                          </v-file-input>
                        </div>
                      </div>
                      <v-col cols="12">
                        <v-text-field v-model="formData.judul_pengumuman" label="Judul Pengumuman" required
                          color="#F9A825" :disabled="disableCounter"></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        Periode Pengumuman
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="formData.start_date" label="Dari" prepend-icon="mdi-calendar"
                              readonly v-bind="attrs" v-on="on" color="#F9A825" :disabled="disableCounter">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="formData.start_date" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                          transition="scale-transition" offset-y min-width="auto">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="formData.end_date" label="Sampai" prepend-icon="mdi-calendar"
                              readonly v-bind="attrs" v-on="on" color="#F9A825" :disabled="disableCounter">
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="formData.end_date" @input="menu3 = false"></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox :items="listKotaDomisili" item-text="DESKRIPSI_DATA" item-value="ID_DATA" multiple
                          chips v-model="formData.lokasi_pengumuman" label="Lokasi Pengumuman" color="#F9A825"
                          :disabled="disableFlag">
                        </v-combobox>
                        <!-- <v-combobox
                            :items="listKotaDomisili"
                            label="Lokasi Pengumuman"
                            required
                            v-model="formData.lokasi_pengumuman"
                            item-text="DESKRIPSI_DATA"
                            item-value="ID_DATA"
                            color="#F9A825"
                            :disabled="disableCounter"
                            multiple
                          ></v-combobox> -->
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox v-model="formData.flag_nasional" label="Flag Nasional" color="orange" value="Y"
                          hide-details :disabled="disableCounter" v-on:change="checkValidasiFlag()"></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea label="Deskripsi Pengumuman" v-model="formData.deskripsi_pengumuman" required
                          color="#F9A825" :disabled="disableCounter" full-width counter></v-textarea>
                      </v-col>
                       <v-col cols="12">
                        <v-textarea label="Link" v-model="formData.url_event" required
                          color="#F9A825" :disabled="disableCounter" full-width counter></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDialogEvent()">
                    Close
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="submitEvent()" :disabled="disableCounter">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <div class="card-body">
              <v-dialog v-model="dialogLoading" width="150px" height="auto">
                <v-card width="150px" height="150px" style="text-align: center">
                  <v-progress-circular :size="70" :width="7" color="orange" indeterminate persistent
                    style="margin-top: 40px"></v-progress-circular>
                </v-card>
              </v-dialog>
              <!-- <div class="row">
                <div class="col">
                  <v-select
                    :items="listKotaDaftar"
                    label="Tao Ying City"
                    required
                    v-model="search_kota"
                    item-text="DESKRIPSI_DATA"
                    item-value="ID_DATA"
                    color="#F9A825"
                    v-on:change="searchData()"
                  ></v-select>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_daftar"
                        label="Tao Ying Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_daftar_raw = parseDate(search_tgl_daftar)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_daftar_raw"
                      v-on:change="searchData()"
                      color="#F9A825"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div> -->
              <v-data-table :headers="headers" :items="pengumuman" :search="search" show-select item-key="ID"
                v-model="selected">
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                      class="mr-2"></v-text-field>
                    <v-btn style="margin-right: 20px" color="#3EB650" dark @click="newEvent()"
                      :disabled="disabledButtonforSU">Pengumuman Baru</v-btn>
                    <v-btn style="margin-right: 20px" color="red" dark @click="deleteEvent()">Hapus Pengumuman</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small class="mr-2" color="red" @click="kirimNotifikasi(item)" v-bind="attrs" v-on="on">
                        mdi-lightning-bolt
                      </v-icon>
                    </template>
                    <span>Broadcast Notifikasi</span>
                  </v-tooltip>
                  <v-icon small @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                </template>
                <!-- <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="initialize"
                  >
                    Reset
                  </v-btn>
                </template> -->
              </v-data-table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import axios from '@/axios'
import FormDaftar from '../../components/modal/FormDaftar.vue'
import FormGraduateTaoying from '../../components/modal/FormGraduateTaoying.vue'
import FormUploadSignature from '../../components/modal/FormUploadSignature.vue'
import DataTableHistory from '../../components/modal/DataTableHistory.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
  data: () => ({
    sortBy: 'NO_TAOYU',
    sortDesc: false,
    search: '',
    searchDataHuangyi: '',
    isMobile: false,
    search_kota: '',
    search_tgl_daftar: '',
    search_tgl_daftar_raw: '',
    dialogAddEvent: false,
    dialogLoading: false,
    dialogGenUser: false,
    listKotaDomisili: [],
    title_dialog: '',
    id_pengumuman: '',
    disableCounter: false,
    disabledButtonforSU: false,
    judul_pengumuman: '',
    menu_jam: false,
    event_jam: null,
    tanggal_event: '',
    lokasi_pengumuman: '',
    flag_nasional: false,
    alamat_event: '',
    deskripsi_pengumuman: '',
    loading_data_huangyi: false,
    menu2: false,
    menu3: false,
    dialogAddAdminEvent: false,
    selected: [],
    dataNotifikasiRaw: {},
    dataHuangYi: [],
    dataAdminHuangYi: [],
    listHuangYi: [],
    listAdminHuangYi: [],
    start_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    end_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    // data_tgl_daftar:'01-01-1990',
    data_tgl_daftar: '',
    data_tgl_daftar_raw: new Date().toISOString().substr(0, 10),
    headers: [
      { text: 'Judul Pengumuman', align: 'start', value: 'JUDUL', },
      { text: 'Lokasi Pengumuman', value: 'LOKASI_PENGUMUMAN', filterable: false },
      // { text: 'Deskripsi', value: 'DESKRIPSI_TEXT' },
      { text: 'Start Date', value: 'START_DATE' },
      // { text: 'Alamat Event', value: 'ALAMAT_EVENT', filterable: false },
      { text: 'End Date', value: 'END_DATE', filterable: false },
      { text: 'Actions', value: 'actions', filterable: false }
    ],
    headersDialog: [
      { text: 'No HuangYi', align: 'start', value: 'NO_HUANGYI', },
      { text: 'Nama', value: 'NAMA_INDO' }
    ],
    headersDialog2: [
      { text: 'No HuangYi', align: 'start', value: 'NO_HUANGYI', },
      { text: 'Nama', value: 'NAMA_INDO' },
      { text: 'Domisili', value: 'KOTA_DOM' }
    ],
    pengumuman: [],
    id_data_table: '',
    id_data_table2: '',
    editedIndex: -1,
    editedItem: [],
    flagEdited: false,
    disableFlag: false,
    url: null,
    data_foto: '',
    role: 0,
    statusDialog: 0,
    singleSelect: false,
    formData: {
      lokasi_pengumuman: []
    },
    dataTables: [],
    rulesImage: [
      v => (v && v.size <= 300000) || 'Foto maks 300 KB',
    ],
  }),
  computed: {
    // formTitle () {
    //     return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    // },
  },
  watch: {
    dialog(val) { val || this.close() },
    dialog2(val) { val || this.close() },
    search_tgl_daftar_raw(val) {
      this.search_tgl_daftar = this.formatDate(this.search_tgl_daftar_raw)
      // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
    },
  },
  created() {
    this.initialize()
  },
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push('/')
    }
  },
  watch: {
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    initialize() {
      // console.log('Dash '+this.$session.get('token'));    
      if (this.$session.get('role') === '1') {
        this.disabledButtonforSU = true;
        axios({
          method: 'get',
          url: 'master_data',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
        }).then(response => {
          // console.log('Kota '+response.data.Kota_Daftar);
          // console.log(response.data);
          this.listKotaDomisili = response.data.Kota_Domisili;
          axios({
            method: 'post',
            url: 'getAllPengumuman',
            headers: {
              Authorization: 'Bearer ' + this.$session.get('token'),
            },
            data: {
              kota_domisili_terdaftar: this.listKotaDomisili
            }
          }).then(response => {
            console.log(response.data.data);
            this.pengumuman = response.data.data;
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
        }).catch(error => {
          Swal.fire({
            title: 'Peringatan',
            icon: 'error',
            text: error
          });
        });
      } else {
        axios({
          method: 'post',
          url: 'get_list_kota_domisili',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            user_id: this.$session.get('user_id')
          }
        }).then(response => {
          this.listKotaDomisili = response.data;
          axios({
            method: 'post',
            url: 'getAllPengumuman',
            headers: {
              Authorization: 'Bearer ' + this.$session.get('token'),
            },
            data: {
              kota_domisili_terdaftar: this.listKotaDomisili
            }
          }).then(response => {
            console.log(response.data.data);
            this.pengumuman = response.data.data;
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }

    },
    newEvent() {
      this.disableCounter = false;
      this.disableFlag = false;
      this.formData.flag_nasional = '';
      // alert(this.disableCounter);
      this.dialogAddEvent = true;
      // this.listKotaDomisili
      // data_kota_split2.forEach(data => {
      //   console.log(data);
      //     tmp2 = this.listKotaDomisili.find(item => item.ID_DATA === parseInt(data));
      //     console.log(tmp2);
      //     if(tmp2) this.formData.lokasi_pengumuman.push(tmp2);
      // });
      let tmp2 = [];
      this.listKotaDomisili.forEach(data => {
        tmp2 = this.listKotaDomisili.find(item => item.ID_DATA === parseInt(data.ID_DATA));
        if (tmp2) this.formData.lokasi_pengumuman.push(tmp2);
      });

      // this.flag_nasional ='Y';
      // this.disableFlag=true;
    },
    formatDate(val) {
      if (!val) {
        return null
      } else {
        return new Date(val).toLocaleDateString('es-CL');

      }
    },
    parseDate(val) {
      if (val !== null && typeof (val) !== 'undefined') {
        return new Date(val).toISOString().substr(0, 10)
      } else {
        return null
      }

    },
    submitEvent() {
      if (this.formData.judul_pengumuman && this.formData.start_date && this.formData.end_date && this.formData.lokasi_pengumuman && this.formData.deskripsi_pengumuman) {
        this.onSubmit();
      } else if (this.formData.data_foto !== null && this.$refs.file.validate() === false) {
        Swal.fire({
          title: 'Peringatan',
          icon: 'error',
          text: 'Ukuran Foto Melebihi Batas!'
        });
      }
      else {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Harap Isi Semua data Event dengan lengkap!'
        });
      }
    },
    closeDialogEvent() {
      this.dialogAddEvent = false;
      this.formData.judul_pengumuman = '';
      this.formData.start_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      this.formData.end_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      this.formData.lokasi_pengumuman = [];
      this.formData.alamat_event = '';
      this.formData.deskripsi_pengumuman = '';
      this.formData.url_event = '';
      this.formData.id_pengumuman = '';
      this.formData.data_foto = '';
      this.formData.dataAdminHuangYi = [];
      this.id_pengumuman = '';
      this.url = null;

    },
    onSubmit() {
      // console.log(this.formData.lokasi_pengumuman);
      // alert(JSON.stringify(this.formData.lokasi_pengumuman));
      let sendData = new FormData();
      sendData.append('judul', this.formData.judul_pengumuman);
      sendData.append('start_date', this.formData.start_date);
      sendData.append('end_date', this.formData.end_date);
      if (this.formData.data_foto) {
        sendData.append('foto', this.formData.data_foto);
      }
      sendData.append('lokasi', JSON.stringify(this.formData.lokasi_pengumuman));
      sendData.append('deskripsi', this.formData.deskripsi_pengumuman);
      sendData.append('url_event',this.formData.url_event);
      sendData.append('flag_nasional', this.formData.flag_nasional);
      sendData.append('user_id', this.$session.get('user_id'));
      if (this.id_pengumuman === '') {
        axios({
          method: 'post',
          url: 'simpanDataPengumuman',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: sendData
        }).then(response => {
          // alert(response.data.data);
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: 'Data Berhasil Disimpan'
          });
          this.buildNotification(response.data.data, JSON.stringify(this.formData.lokasi_pengumuman), this.formData.flag_nasional, this.formData.judul_pengumuman, this.formData.deskripsi_pengumuman);
          this.closeDialogEvent();
          this.initialize();
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      } else {
        sendData.append('id_pengumuman', this.id_pengumuman);
        axios({
          method: 'post',
          url: 'updateDataPengumuman',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: sendData
        }).then(response => {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: 'Data Berhasil Diupdate'
          });
          this.closeDialogEvent();
          this.initialize();
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }
    },
    editItem(item) {
      // console.log(item);

      const today = new Date();
      const yyyy = today.getFullYear();
      let mm = today.getMonth() + 1; // Months start at 0!
      let dd = today.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      var dateNow = yyyy + '-' + mm + '-' + dd;
      if (this.$session.get('role') === '1') {
        this.disableCounter = true;
      } else {

        if (item.END_DATE < dateNow) {
          this.disableCounter = true;
          this.disableFlag = true;
          if (item.LOKASI_PENGUMUMAN === 'ALL') {
            this.formData.flag_nasional = 'Y'
            // this.disableFlag = true;
          } else {
            this.formData.flag_nasional = null
          }
        }
        else {
          if (item.LOKASI_PENGUMUMAN === 'ALL') {
            this.formData.flag_nasional = 'Y'
            this.disableFlag = true;
            // this.disableFlag = true;
          } else {
            this.formData.flag_nasional = null
            this.disableFlag = false;
          }
          this.disableCounter = false;
        }
      }
      this.dataAdminHuangYi.splice(0);
      this.id_pengumuman = item.ID;
      this.formData.judul_pengumuman = item.JUDUL;
      this.formData.start_date = item.START_DATE;
      this.formData.end_date = item.END_DATE;
      // this.formData.lokasi_pengumuman = response.data.data[0].ID_LOKASI;
      this.formData.deskripsi_pengumuman = item.DESKRIPSI_TEXT;
      this.formData.url_event = item.LINK;
      if (item.URL_GAMBAR) {
        // this.url= 'http://sd6webdev.indomaret.lan/Taoyu/laravel-passport/'+item.URL_GAMBAR;
        // this.formData.url_photo=this.data.editedItem.URL_FOTO;

        this.url = 'https://zhengdaolishanghu.com/laravel/' + item.URL_GAMBAR;
        // this.url= URL.createObjectURL('./'+this.formData.url_photo);
      }
      let tmp2 = [];
      let data_kota_split2 = item.ID_LOKASI.split(',');
      data_kota_split2.forEach(data => {
        tmp2 = this.listKotaDomisili.find(item => item.ID_DATA === parseInt(data));
        if (tmp2) this.formData.lokasi_pengumuman.push(tmp2);
      });
      // console.log(this.formData.lokasi_pengumuman);

      this.dialogAddEvent = true;
    },
    deleteItem(item) {
      axios({
        method: 'post',
        url: 'deletePengumuman',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id_pengumuman: item.ID,
          single_delete: 'Y',
          role_id: this.$session.get('role'),
          user_id: this.$session.get('user_id')
        }
      }).then(response => {
        if (response.data === 'Data Event Masih Aktif!') {
          Swal.fire({
            title: 'Peringatan',
            icon: 'warning',
            text: response.data
          });
        } else {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: response.data
          });
        }
        this.initialize();
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
    },
    deleteEvent() {

      axios({
        method: 'post',
        url: 'deletePengumuman',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          data_pengumuman: this.selected,
          single_delete: 'N',
          role_id: this.$session.get('role'),
          user_id: this.$session.get('user_id')
        }
      }).then(response => {
        if (response.data === 'Data Event Masih Aktif!') {
          Swal.fire({
            title: 'Peringatan',
            icon: 'warning',
            text: response.data
          });
        } else {
          Swal.fire({
            title: 'Peringatan',
            icon: 'success',
            text: response.data
          });
        }
        this.initialize();
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
    },
    cetakAbsensi(item) {
      console.log(item);
    },
    closeDalogAddAdminEvent() {
      this.dialogAddAdminEvent = false;
    },
    checkValidasiFlag() {
      // alert(this.formData.flag_nasional);
      if (this.formData.flag_nasional !== 'Y' || this.formData.flag_nasional == null) {
        // alert("SINI");
        this.disableFlag = false;
      } else {
        // alert("MASOK")
        this.formData.lokasi_pengumuman = [];
        this.disableFlag = true;
      }
    },
    getDataHuangYiDomisili() {
      this.listHuangYi.splice(0);
      if (this.lokasi_pengumuman === '') {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Anda Belum Memilih Lokasi Event!'
        });
      } else {
        this.dialogAddAdminEvent = true;
        this.dataHuangYi = [];
        this.loading_data_huangyi = true;
        axios({
          method: 'post',
          url: 'get_data_huangyi_for_admin_event',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            kota_domisili: this.lokasi_pengumuman,
            list_no_HuangYi: this.dataAdminHuangYi
          }
        }).then(response => {
          // console.log(response.data);
          this.dataHuangYi = response.data;
          this.loading_data_huangyi = false;
          // this.pengumuman=response.data.data;
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
      }
    },
    insertHuangYitoAdmin() {
      this.listHuangYi.forEach((item) => {
        this.dataAdminHuangYi.push({
          ID_TRX: item.ID_TRX,
          NO_HUANGYI: item.NO_HUANGYI,
          NAMA_INDO: item.NAMA_INDO
        })
      });
      this.dialogAddAdminEvent = false;
    },
    deleteAdminAbsen() {
      if (this.listAdminHuangYi.length === 0) {
        Swal.fire({
          title: 'Peringatan',
          icon: 'warning',
          text: 'Anda Belum Memilih Admin Yang Akan diHapus!'
        });
      } else {
        for (var i = 0; i < this.listAdminHuangYi.length; i++) {
          const index = this.dataAdminHuangYi.indexOf(this.listAdminHuangYi[i]);
          this.dataAdminHuangYi.splice(index, 1);
        }
        this.listAdminHuangYi.splice(0);
      }
    },
    resetListAdminHuangYi() {
      this.dataAdminHuangYi.splice(0);
    },
    Preview_image(event) {
      this.url = URL.createObjectURL(this.formData.data_foto)
    },
    kirimNotifikasi(data) {
      console.log(data);
      this.buildNotificationSend(data.ID, data.ID_LOKASI, data.JUDUL, data.DESKRIPSI_TEXT);
    },
    buildNotificationSend(id, lokasi, judul, deskripsi) {
      // alert(id);
      // alert(lokasi);
      // alert(flag_nasional);
      // alert(flagNasional);
      var concatIDPengumuman = '';
      var concatLinkURLGambar = '';
      axios({
        method: 'post',
        url: 'getPathFotoByAnnouncementID',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id_pengumuman: id
        }
      }).then(response => {
        // concatLinkURLGambar = 'http://sd6webdev.indomaret.lan/Taoyu/laravel-passport/' + response.data.URL_GAMBAR;
        concatLinkURLGambar = 'https://zhengdaolishanghu.com/laravel/' + response.data.URL_GAMBAR;
        // alert(concatLinkURLGambar)
        axios({
          method: 'post',
          url: 'getDataNotificationIDSend',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            lokasi_event: lokasi,
          }
        }).then(response => {
          this.dataNotifikasiRaw = response.data.data;
          // console.log(this.dataNotifikasiRaw);
          // alert(this.dataNotifikasiRaw.length);
          var counter = 1;
          try {
            for (let i = 0; i < this.dataNotifikasiRaw.length; i++) {
              // console.log(this.dataNotifikasiRaw[i]);1
              concatIDPengumuman += '"' + this.dataNotifikasiRaw[i].token_notifikasi + '",';
              if (counter % 100 === 0) {
                concatIDPengumuman = concatIDPengumuman.slice(0, -1);
                // console.log(this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar));
                axios({
                  method: 'post',
                  url: 'https://fcm.googleapis.com/fcm/send',
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
                  },
                  data: this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar, judul, deskripsi)
                }).then(response => {
                  console.log(response);
                  // this.initialize();
                }).catch(error => {
                  // Swal.fire({
                  //            title:'Peringatan',
                  //            icon :'error',
                  //            text:'Failed to retrieve List City !'
                  //    });
                });
                concatIDPengumuman = '';
              }
              counter = counter + 1;
            }

          } catch (err) {
            console.log(err);
          }
          concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          axios({
            method: 'post',
            url: 'https://fcm.googleapis.com/fcm/send',
            headers: {
              "Content-Type": "application/json",
              "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
            },
            data: this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar, judul, deskripsi)
          }).then(response => {
            console.log(response);
            // this.initialize();
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
          this.initialize();
          // console.log(concatIDPengumuman);
          // alert("test");
          // // alert(concatIDPengumuman);
          // // this.dataNotifikasiRaw.forEach(data => {
          // //   concatIDPengumuman += '"' + data.token_notifikasi + '",';
          // // }); 
          // // concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          // // console.log(concatIDPengumuman);
          // console.log(this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar));
          // axios({
          //   method: 'post',
          //   url: 'https://fcm.googleapis.com/fcm/send',
          //   headers: {
          //     "Content-Type": "application/json",
          //     "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
          //   },
          //   data: this.concatNotifikasi(concatIDPengumuman)
          // }).then(response => {
          //   console.log(response);
          //   // this.initialize();
          // }).catch(error => {
          //   // Swal.fire({
          //   //            title:'Peringatan',
          //   //            icon :'error',
          //   //            text:'Failed to retrieve List City !'
          //   //    });
          // });
          // this.initialize();
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
        // console.log(isiNotifikasi);
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
      // axios({
      //   method: 'get',
      //   url: 'getDataNotificationID',
      //   headers: {
      //     Authorization: 'Bearer ' + this.$session.get('token'),
      //   }
      // }).then(response => {
      //   this.dataNotifikasiRaw = response.data.data;
      //   this.dataNotifikasiRaw.forEach(data => {
      //     concatIDPengumuman += '"' + data.token_notifikasi + '",';
      //   }); 
      //   concatIDPengumuman = concatIDPengumuman.slice(0, -1);
      //   console.log(concatIDPengumuman);
      //   console.log(this.concatNotifikasi(concatIDPengumuman));
      //   axios({
      //     method: 'post',
      //     url: 'https://fcm.googleapis.com/fcm/send',
      //     headers: {
      //       "Content-Type": "application/json",
      //       "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
      //     },
      //     data: this.concatNotifikasi(concatIDPengumuman)
      //   }).then(response => {
      //     console.log(response);
      //     // this.initialize();
      //   }).catch(error => {
      //     // Swal.fire({
      //     //            title:'Peringatan',
      //     //            icon :'error',
      //     //            text:'Failed to retrieve List City !'
      //     //    });
      //   });
      //   // this.initialize();
      // }).catch(error => {
      //   // Swal.fire({
      //   //            title:'Peringatan',
      //   //            icon :'error',
      //   //            text:'Failed to retrieve List City !'
      //   //    });
      // });
      // console.log(isiNotifikasi);


    },
    buildNotification(id, lokasi, flag_nasional, judul, deskripsi) {
      // alert(id);
      // alert(lokasi);
      // alert(flag_nasional);
      var flagNasional = '';
      if (flag_nasional != 'Y') {
        flagNasional = 'N';
      } else {
        flagNasional = 'Y';
      }
      // alert(flagNasional);
      var concatIDPengumuman = '';
      var concatLinkURLGambar = '';
      axios({
        method: 'post',
        url: 'getPathFotoByAnnouncementID',
        headers: {
          Authorization: 'Bearer ' + this.$session.get('token'),
        },
        data: {
          id_pengumuman: id
        }
      }).then(response => {
        // concatLinkURLGambar = 'http://sd6webdev.indomaret.lan/Taoyu/laravel-passport/' + response.data.URL_GAMBAR;
        concatLinkURLGambar = 'https://zhengdaolishanghu.com/laravel/' + response.data.URL_GAMBAR;
        // alert(concatLinkURLGambar)
        axios({
          method: 'post',
          url: 'getDataNotificationID',
          headers: {
            Authorization: 'Bearer ' + this.$session.get('token'),
          },
          data: {
            lokasi_event: lokasi,
            flag_nasional_event: flag_nasional
          }
        }).then(response => {
          this.dataNotifikasiRaw = response.data.data;
          // console.log(this.dataNotifikasiRaw);
          // alert(this.dataNotifikasiRaw.length);
          var counter = 1;
          try {
            for (let i = 0; i < this.dataNotifikasiRaw.length; i++) {
              // console.log(this.dataNotifikasiRaw[i]);1
              concatIDPengumuman += '"' + this.dataNotifikasiRaw[i].token_notifikasi + '",';
              if (counter % 100 === 0) {
                concatIDPengumuman = concatIDPengumuman.slice(0, -1);
                // console.log(this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar));
                axios({
                  method: 'post',
                  url: 'https://fcm.googleapis.com/fcm/send',
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
                  },
                  data: this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar, judul, deskripsi)
                }).then(response => {
                  console.log(response);
                  // this.initialize();
                }).catch(error => {
                  // Swal.fire({
                  //            title:'Peringatan',
                  //            icon :'error',
                  //            text:'Failed to retrieve List City !'
                  //    });
                });
                concatIDPengumuman = '';
              }
              counter = counter + 1;
            }

          } catch (err) {
            console.log(err);
          }
          concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          axios({
            method: 'post',
            url: 'https://fcm.googleapis.com/fcm/send',
            headers: {
              "Content-Type": "application/json",
              "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
            },
            data: this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar, judul, deskripsi)
          }).then(response => {
            console.log(response);
            // this.initialize();
          }).catch(error => {
            // Swal.fire({
            //            title:'Peringatan',
            //            icon :'error',
            //            text:'Failed to retrieve List City !'
            //    });
          });
          this.initialize();
          // console.log(concatIDPengumuman);
          // alert("test");
          // // alert(concatIDPengumuman);
          // // this.dataNotifikasiRaw.forEach(data => {
          // //   concatIDPengumuman += '"' + data.token_notifikasi + '",';
          // // }); 
          // // concatIDPengumuman = concatIDPengumuman.slice(0, -1);
          // // console.log(concatIDPengumuman);
          // console.log(this.concatNotifikasi(concatIDPengumuman, concatLinkURLGambar));
          // axios({
          //   method: 'post',
          //   url: 'https://fcm.googleapis.com/fcm/send',
          //   headers: {
          //     "Content-Type": "application/json",
          //     "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
          //   },
          //   data: this.concatNotifikasi(concatIDPengumuman)
          // }).then(response => {
          //   console.log(response);
          //   // this.initialize();
          // }).catch(error => {
          //   // Swal.fire({
          //   //            title:'Peringatan',
          //   //            icon :'error',
          //   //            text:'Failed to retrieve List City !'
          //   //    });
          // });
          // this.initialize();
        }).catch(error => {
          // Swal.fire({
          //            title:'Peringatan',
          //            icon :'error',
          //            text:'Failed to retrieve List City !'
          //    });
        });
        // console.log(isiNotifikasi);
      }).catch(error => {
        // Swal.fire({
        //            title:'Peringatan',
        //            icon :'error',
        //            text:'Failed to retrieve List City !'
        //    });
      });
      // axios({
      //   method: 'get',
      //   url: 'getDataNotificationID',
      //   headers: {
      //     Authorization: 'Bearer ' + this.$session.get('token'),
      //   }
      // }).then(response => {
      //   this.dataNotifikasiRaw = response.data.data;
      //   this.dataNotifikasiRaw.forEach(data => {
      //     concatIDPengumuman += '"' + data.token_notifikasi + '",';
      //   }); 
      //   concatIDPengumuman = concatIDPengumuman.slice(0, -1);
      //   console.log(concatIDPengumuman);
      //   console.log(this.concatNotifikasi(concatIDPengumuman));
      //   axios({
      //     method: 'post',
      //     url: 'https://fcm.googleapis.com/fcm/send',
      //     headers: {
      //       "Content-Type": "application/json",
      //       "Authorization": "key=AAAAmHQbdBc:APA91bESWZqn98GvZAM5IqbTs_cfUz9OCrln0fr6ameLFU6HFQdVnjvIOt-LchLYu4habbjZejlVj3J_lf1L6IwiMdHFwX9gBnl4UnGO2rN7pUUYL4TSZYDtb_Ge1ue1FsPQcXN4_0dU"
      //     },
      //     data: this.concatNotifikasi(concatIDPengumuman)
      //   }).then(response => {
      //     console.log(response);
      //     // this.initialize();
      //   }).catch(error => {
      //     // Swal.fire({
      //     //            title:'Peringatan',
      //     //            icon :'error',
      //     //            text:'Failed to retrieve List City !'
      //     //    });
      //   });
      //   // this.initialize();
      // }).catch(error => {
      //   // Swal.fire({
      //   //            title:'Peringatan',
      //   //            icon :'error',
      //   //            text:'Failed to retrieve List City !'
      //   //    });
      // });
      // console.log(isiNotifikasi);


    },
    concatNotifikasi(data, gambar, judul, deskripsi) {
      var textDesc = deskripsi;
      var string = "{\"registration_ids\": [" + data + "],\"notification\": \{\"title\": \"" + judul + "\",\"body\": \"" + textDesc.substr(0, 100) + "\",\"image\": \"" + gambar + "\"\}} ";

      return string;
      // return {
      //   "registration_ids": [data],
      //   "notification": {
      //     "title": "Upacara TaoYing & Kweepang – Jakarta 5 June 2022",
      //     "body": "Telah sukses diadakan upacara Taoying di Jakarta Zhen Cheng Gong Taokwan dipimpin oleh Lie Ming Shen Dao Shi, dan dihadiri oleh 30 Taoyu yang baru di taoying",
      //     "image": "https://siutao.com/wp-content/uploads/2022/06/Taoying-5-Juni-2022-Zhen-Cheng-Gong-3-1200x480.jpeg"
      //   }
    }


  },
  components: {
    FormDaftar,
    FormGraduateTaoying,
    FormUploadSignature,
    DataTableHistory
    // FormValidasi,
  },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
